import { Badge, Icon, Loader, Paragraph, Title } from "@sicredi/react";
import styles from "./styles.module.scss";
import { ICardMenuConsorcio } from "./model";
import { useNavigate } from "react-router-dom";
import { PAGE } from "#/constants";
import { useContext, useState } from "react";
import { ContextAPI } from "#/contextProver/ContextProver";
import { getVendasListaProposta } from "#/api/getVendasListaProposta";
import { toastErrorMenssage } from "#/contextProver/ContextProverServices";

export const CardMenuConsorcio: React.FC<ICardMenuConsorcio> = ({
  title,
  subTitle,
  description,
  statusIcon,
  textIcon,
  idProduto,
  idDocumento,
  descriptionSecondLine,
}) => {
  const {
    setIdProduto,
    setIdDocumento,
    codigoComissionado,
    documento,
    setVendasListaProposta,
    setIsMenuConsorcio,
  } = useContext(ContextAPI);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleGoTracking = async () => {
    setIdProduto(idProduto);
    setIdDocumento(idDocumento);
    setIsLoading(true);
    try {
      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);

      setIsLoading(false);
      setIsMenuConsorcio(true);
      navigate(PAGE.TRACKING);
    } catch {
      toastErrorMenssage();
    }
  };
  return (
    <div
      onClick={handleGoTracking}
      className={styles.card_view}
      style={{ borderColor: textIcon === "Contratado" ? "#1e9b32" : "#E6A500" }}
    >
      <Loader show={isLoading} fullScreen />
      <div className={styles.title_card}>
        <div>
          <Title size="large" weight="light" as="h3">
            {title}
          </Title>
          {subTitle && (
            <Title
              as="h3"
              weight="semi-bold"
              size="large"
              className={styles.sub_title}
            >
              {subTitle}
            </Title>
          )}
        </div>
        <Icon name="chevron-right" size={24} color="#33820D" />
      </div>

      <div className={styles.description_container}>
        <Paragraph size="small" weight="normal">
          {description}
        </Paragraph>

        {descriptionSecondLine && (
          <Paragraph size="small" weight="normal">
            {descriptionSecondLine}
          </Paragraph>
        )}
      </div>

      <Badge
        aria-label="Info consorcio"
        appearance={statusIcon}
        data-testid="textIcon"
      >
        {textIcon}
      </Badge>
    </div>
  );
};
